var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1022 15.0064C14.9374 15.0064 14.7843 14.9398 14.6711 14.8187L8.35671 8.06694C8.24684 7.94947 8.18814 7.79445 8.19155 7.63048C8.19496 7.46651 8.25988 7.31416 8.37457 7.20152L8.3818 7.19443C8.49298 7.08508 8.63968 7.0249 8.79481 7.0249C8.95967 7.0249 9.11279 7.09156 9.22598 7.21263L15.5403 13.9644C15.7682 14.208 15.7602 14.5962 15.5226 14.8298L15.5154 14.8369C15.404 14.9462 15.2573 15.0064 15.1022 15.0064Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61121 14.9204C8.44635 14.9204 8.29333 14.8537 8.18004 14.7326L8.17312 14.7252C8.06324 14.6078 8.00454 14.4527 8.00795 14.2888C8.01136 14.1248 8.07629 13.9725 8.19098 13.8598L14.9914 7.17587C15.1026 7.06652 15.2493 7.00635 15.4044 7.00635C15.5692 7.00635 15.7223 7.073 15.8356 7.19408L15.8425 7.20149C15.9524 7.31896 16.0111 7.47398 16.0077 7.63795C16.0043 7.80192 15.9393 7.95426 15.8246 8.0669L9.02422 14.7508C8.91294 14.8602 8.76634 14.9204 8.61121 14.9204Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.318bd4bc607092445fefb35b8ba00e87.svg";
export { ForwardRef as ReactComponent };